export enum Audience {
  HOMEBUYER = 'homebuyer',
  AGENT = 'agent',
  LENDER = 'lender',
}
